<template>
    <transition name="layout-fade">
        <loader v-if="loader"/>
        <v-layout wrap column class="layout-add layout-add--max_width" v-else>
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Редактировать акцию</v-toolbar-title>
                <v-spacer/>
                <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading" @click="sendForm">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
                <v-btn color="error" class="v-btn--save" @click="dialog = true">
                    Удалить
                </v-btn>
            </v-toolbar>
            <v-form class="form-add">
                <v-flex xs12>
                    <v-subheader class="pa-0">Тайтл</v-subheader>
                    <v-text-field
                        ref="name"
                        v-model="sR.name"
                        v-validate="'required'"
                        data-vv-name="name"
                        :error-messages="errors.collect('name')"
                        single-line
                        text
                        solo
                        required/>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs6>
                            <v-subheader class="pa-0">Короткое описание</v-subheader>
                            <v-textarea
                                ref="sR_description"
                                v-model="sR.description"
                                v-validate="'required|max:140'"
                                data-vv-name="description"
                                :error-messages="errors.collect('description')"
                                text
                                solo
                                single-line
                                required
                                counter="140"/>
                            <v-subheader class="pa-0">Статус</v-subheader>
                            <v-checkbox :label="sR.status ? 'Включен' : 'Отключен'" v-model="sR.status" class="mt-0"/>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <upload-img :image-width="1024" :image-height="1024" v-model="sR.img" :content-area="12"
                                        style="max-width: 253px;">
                                <div slot="activator">
                                    <v-avatar size="100%" v-ripple tile v-if="sR.img.imageURL">
                                        <img :src="sR.img.imageURL" alt="Изображение для категории"/>
                                    </v-avatar>
                                    <v-avatar size="100%" v-ripple tile v-else-if="!sR.img.imageURL && sR.img">
                                        <img :src="rootURL + sR.img"
                                             alt="Нажмите чтобы добавить картинку для категории"/>
                                    </v-avatar>
                                    <v-avatar size="100%" v-ripple class="grey lighten-3" tile v-else>
                                        <img src="/static/img/media/image_blank.svg"
                                             alt="Нажмите чтобы добавить картинку для категории"/>
                                    </v-avatar>
                                </div>
                            </upload-img>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Выберите тип</v-subheader>
                            <v-select
                                :items="types"
                                item-value="key"
                                item-text="value"
                                v-model="sR.stock_type"
                                text
                                solo/>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Количество наградных бонусов</v-subheader>
                            <v-text-field
                                ref="stockValue"
                                mask="######"
                                v-model="sR.stock_value"
                                v-validate="'required|min_value:1'"
                                data-vv-name="stock_value"
                                :error-messages="errors.collect('stock_value')"
                                single-line
                                text
                                solo
                                required/>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Дата начало</v-subheader>
                            <v-menu
                                ref="startMenu"
                                v-if="!dateUnlim"
                                v-model="startMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px">
                                <template slot="activator">
                                    <v-text-field
                                        v-model="sR.start_date"
                                        prepend-icon="event"
                                        readonly
                                        text
                                        solo/>
                                </template>
                                <v-date-picker
                                    ref="startPicker"
                                    locale="ru-ru"
                                    first-day-of-week="1"
                                    v-model="sR.start_date"
                                    :min="new Date().toISOString().substr(0, 10)"
                                    @change="saveStartMenu"/>
                            </v-menu>
                            <v-checkbox v-model="dateUnlim" label="Срок не установлен"/>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Дата окончания</v-subheader>
                            <v-menu
                                ref="endMenu"
                                v-if="!dateUnlim"
                                v-model="endMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px">
                                <template slot="activator">
                                    <v-text-field
                                        v-model="sR.end_date"
                                        prepend-icon="event"
                                        readonly
                                        text
                                        solo/>
                                </template>
                                <v-date-picker
                                    ref="endPicker"
                                    locale="ru-ru"
                                    first-day-of-week="1"
                                    v-model="sR.end_date"
                                    :min="new Date(tomorrow).toISOString().substr(0, 10)"
                                    @change="saveEndMenu"/>
                            </v-menu>
                            <v-checkbox disabled label="Срок не установлен" v-model="dateUnlimCopy" v-show="dateUnlim"/>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-subheader class="pa-0">Основной Текст</v-subheader>
                    <wysiwyg v-model="sR.text"/>
                </v-flex>
            </v-form>
            <v-dialog v-model="dialog" persistent max-width="45%">
                <v-card>
                    <v-card-title class="headline">
                        <h4>Подтверждение удаление</h4>
                    </v-card-title>
                    <v-card-text>
                        Акция будет удалена <br/> Вы уверены что хотите этого?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <template v-if="waitDelete">
                            <v-progress-linear indeterminate color="warning" class="mb-0"/>
                        </template>
                        <template v-else>
                            <v-btn color="info" class="v-btn--save" @click="deleteStockRegister">
                                Продолжить
                            </v-btn>
                            <v-btn color="error" class="v-btn--save" @click="dialog = false">
                                Отменить
                            </v-btn>
                        </template>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </transition>
</template>

<script>
    import config from '../../../../config'
    import StockReg from '../../../../api/stockregister'
    import UploadImg from '../../../../components/Media/Upload'
    import Loader from '../../../../components/Loader/Layout'

    export default {
        name: 'editStockRegister',
        components: {
            UploadImg,
            Loader
        },
        $_veeValidate: {
            validator: 'new'
        },
        data: () => ({
            rootURL: '',
            loading: false,
            loader: false,
            startMenu: false,
            endMenu: false,
            dateUnlim: false,
            dateUnlimCopy: true,
            tomorrow: new Date(),
            types: [
                {
                    key: 0,
                    value: 'Любая платформа'
                },
                {
                    key: 1,
                    value: 'Моб.приложение'
                },
                {
                    key: 2,
                    value: 'Моб.приложение - iOs'
                },
                {
                    key: 3,
                    value: 'Моб.приложение - Android'
                },
                {
                    key: 4,
                    value: 'Сайт'
                },
            ],
            sR: {
                name: '',
                img: '',
                status: true,
                description: '',
                text: '',
                stock_type: 1,
                stock_value: null,
                start_date: null,
                end_date: null
            },
            dialog: false,
            waitDelete: false,
            dictionary: {
                custom: {
                    name: {
                        required: 'Название не введено'
                    },
                    description: {
                        required: 'Короткое описание не введено'
                    },
                    stock_value: {
                        min_value: 'Бонус не может быть равен нулью'
                    }
                }
            }
        }),
        mounted () {
            this.rootURL = config.rootPath
            this.$validator.localize('ru', this.dictionary)
            this.getStockRegister(this.$route.params.stockRegId)
        },
        methods: {
            getStockRegister (id) {
                this.loader = true

                StockReg
                    .getById(id)
                    .then(response => {
                        this.sR = response.data.data

                        if (!this.sR.start_date && !this.sR.end_date) {
                            this.dateUnlim = true
                        } else {
                            const startDate = new Date(response.data.data.start_date).setHours(5)
                            const endDate = new Date(response.data.data.end_date).setHours(5)

                            this.sR.start_date = new Date(startDate).toISOString().substr(0, 10)
                            this.sR.end_date = new Date(endDate).toISOString().substr(0, 10)
                        }
                    })
                    .catch(error => {
                        this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] })
                        this.$router.push({ name: 'stockRegister' })
                    })
                    .finally(() => this.loader = false)
            },
            saveStartMenu (date) {
                this.sR.endDate = null
                this.tomorrow = new Date(date)
                this.tomorrow.setDate(this.tomorrow.getDate() + 1)
                this.$refs.startMenu.save(date)
            },
            saveEndMenu (date) {
                if (!this.sR.start_date) {
                    this.sR.end_date = null

                    return
                }

                this.$refs.endMenu.save(date)
            },
            sendForm () {
                this.$validator
                    .validateAll()
                    .then(isValid => {
                        if (!isValid) return

                        if (this.dateUnlim) {
                            this.sR.start_date = null
                            this.sR.end_date = null
                        }

                        if (!this.dateUnlim && !this.sR.start_date && !this.sR.end_date) {
                            this.$store.commit('showSnackbar', { text: 'Выберите дату' })

                            return
                        }

                        this.loading = true

                        StockReg
                            .edit(this.sR)
                            .then(response => {
                                this.$store.commit('updateStockRegister', response.data.data)
                                this.$store.commit('showSnackbar', {
                                    text: 'Успех! Акция отредактировано',
                                    color: 'success'
                                })
                            })
                            .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                            .finally(() => this.loading = false)
                    })
                    .catch(error => new Error(error))
            },
            deleteStockRegister () {
                this.waitDelete = true

                StockReg
                    .delete(this.sR.id)
                    .then(response => {
                        this.$store.commit('deleteStockRegister', { id: this.sR.id })
                        this.$store.commit('showSnackbar', {
                            text: response.data.data,
                            color: 'success'
                        })
                        this.$router.push({ name: 'stockRegister' })
                    })
                    .catch(error => new Error(error))
                    .finally(() => {
                        this.dialog = false
                        this.waitDelete = false
                    })
            }
        },
        beforeRouteLeave (to, from, next) {
            next()
        },
        beforeRouteUpdate (to, from, next) {
            this.sR = this.getStockRegister(to.params.stockRegId)
            next()
        }
    }
</script>
